import { getSourceAccessState } from './QualityReviewSourceAccess'

export const normalizeUploadName = name => String(name || '').split(/[\\/]/).pop().replace(/[\r\n"]/g, '_').trim()

export const uploadCategoryLabel = key => ({ bizfile: 'BizFile', annual_return: 'Annual Return', compilation_fs: 'Financial statements', tax_computation: 'Tax documents' }[key] || 'Other documents')

export function buildReviewUploads(review, localGroups = {}) {
    const local = Object.entries(localGroups).flatMap(([bundleKey, files]) => (files || []).map(file => ({ file, bundleKey })))
    const bizfile = review?.sourceOfTruth?.bizfile
    const annualReturn = review?.sourceOfTruth?.annualReturn
    const candidates = [
        ...(annualReturn?.name ? [{ ...annualReturn, bundleKey: 'annual_return' }] : []),
        ...(bizfile?.name ? [{ ...bizfile, bundleKey: 'bizfile' }] : []),
        ...(review?.files || [])
    ]
    const entries = []
    const seen = new Set()
    for (const item of candidates) {
        if (!item?.name) continue
        const bundleKey = item.role === 'bizfile' ? 'bizfile' : ['annual_return', 'annualReturn'].includes(item.role) ? 'annual_return' : item.bundleKey || 'other_documents'
        const key = item.id || `${bundleKey}:${item.name}`
        if (seen.has(key)) continue
        seen.add(key)
        const matches = local.filter(entry => normalizeUploadName(entry.file.name) === normalizeUploadName(item.name) && entry.bundleKey === bundleKey)
        entries.push({ fileId: String(item.id || ''), fileName: item.name, bundleKey, localFile: matches.length === 1 ? matches[0].file : null })
    }
    for (const entry of review?.sourceAccess?.retentionEnabled ? [] : local) {
        if (!entries.some(item => normalizeUploadName(item.fileName) === normalizeUploadName(entry.file.name) && item.bundleKey === entry.bundleKey)) {
            entries.push({ fileId: '', fileName: entry.file.name, bundleKey: entry.bundleKey, localFile: entry.file })
        }
    }
    const access = getSourceAccessState(review)
    return entries.map(entry => ({ ...entry, canOpen: review?.sourceAccess?.retentionEnabled
        ? access.canOpen && access.retainedFileIds.includes(entry.fileId)
        : Boolean(entry.localFile) }))
}

export function reviewUploadsUnavailableReason(entries) {
    if (!entries.some(entry => entry.bundleKey === 'bizfile')) return 'The original BizFile is unavailable. Start a new review and upload the complete batch again.'
    if (entries.some(entry => !entry.canOpen)) return 'Some original files are expired, deleted or restricted. You can view the available files, or start a new review and upload the complete batch again.'
    return ''
}

// Restore every original upload before changing the screen; never silently run a partial pack.
export async function restoreReviewUploads(review, entries, download, onProgress = () => {}) {
    const unavailable = reviewUploadsUnavailableReason(entries)
    if (unavailable) throw new Error(unavailable)
    const groups = { bizfile: [], annual_return: [], compilation_fs: [], tax_computation: [], other_documents: [] }
    for (const [index, entry] of entries.entries()) {
        onProgress(index + 1, entries.length)
        const file = review.sourceAccess?.retentionEnabled ? await download(entry) : entry.localFile
        if (!file || !file.size) throw new Error(`${entry.fileName} could not be restored. The original review has been kept.`)
        const key = Object.prototype.hasOwnProperty.call(groups, entry.bundleKey) ? entry.bundleKey : 'other_documents'
        groups[key].push(file)
    }
    if (groups.bizfile.length !== 1) throw new Error('The original BizFile could not be identified. Start a new review and upload the complete batch again.')
    if (groups.annual_return.length > 1) throw new Error('The original Annual Return could not be identified. Start a new review and upload the complete batch again.')
    return groups
}
